import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../../../widgets/components/UI/InfoCard2'
import { Formik, Form } from 'formik'
import TextArea from '../../../../widgets/components/Input/TextArea'
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import TextInput from '../../../../widgets/components/Input/TextInput'
import deleteicon from '../../../../../../media/stakeholders/ic-delete.svg'
import { ToolTipUIForModal } from '../../../../widgets/components/UI/ToolTipUIForModal'
import { InputWithSub } from '../../../../widgets/components/Input/InputWithSub'
import { TransactionModalType } from '../../core/_models'
import { useCurrency } from '../../../../../hooks/useCurrency'
import { useGetAllSecurityClassesDropdown } from '../../../../../hooks/useGetAllSecurityClassesDropdown'
import { useAuth } from '../../../../auth'
import * as Yup from 'yup'
import TagManager from 'react-gtm-module'
import { toast } from 'react-toastify'
import { GTMEvent } from '../../../../../hooks/gtmHelpers'
import {
  updateBuybackTransaction,
  createBuybackTransaction,
  getBuybackTransactionById,
} from '../../core/_requests'
import Skeleton from 'react-loading-skeleton'

import { SecurityClassDropdown } from '../../../components/security-class-dropdown'
import TagifyInput from '../../../../shared-access/components/tagify-input'
import { allowedFileTypes } from '../../../../../core/_constants'
import { getFileType } from '../../../../../core/_util'
import { FileUpload } from '../../../../widgets/components/FileUpload'

import React from 'react'
import { buybackMethodOptions, BuybackMethods, TransactionModals } from '../../core/_constants'
import SelectSearchInput from '../../../../widgets/components/Input/SelectSearchInput'
import DataTableForManualBuyback from './DataTableForManualBuyback'
import { DeleteFileConfirmationModal } from '../../../components/delete-file-confirmation-modal'
import brandingConfig from '../../../../../../config/brandingConfig'

export default function AddBuybackModal({
  openModal,
  isActive,
  setIsActive,
  buybackTransactionId,
  setIsBuybackTransactionCreateOrUpdate,
  setSidebar,
  setModalType,
  setIsShareClassDropdown,
  setIsBuybackCreate,
  isBuybackCreate,
}: {
  isActive: boolean
  setIsActive: () => void
  buybackTransactionId?: string | null
  setIsBuybackTransactionCreateOrUpdate: Dispatch<SetStateAction<boolean>>
  setSidebar: Dispatch<SetStateAction<number>>
  openModal: (modalType: TransactionModalType) => void
  setIsShareClassDropdown: Dispatch<SetStateAction<boolean>>
  setIsBuybackCreate: Dispatch<SetStateAction<boolean>>
  setModalType: Dispatch<SetStateAction<TransactionModalType>>
  isBuybackCreate?: boolean
}) {
  const { formatMessage } = useIntl()
  const [currentDocumentStep, setCurrentDocumentStep] = useState(1)
  const { currencyOptions } = useCurrency()
  const { companyCurrency, companyId, currentUser } = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteFileId, setDeleteFileId] = useState<any>(null)
  const { shareholderId } = useParams()
  const formikRef = useRef<any>(null)
  const fileRef = useRef<any>([])
  const [modalStatus, setModalStatus] = useState(false)

  const [isNotInitialized, setIsNotInitialized] = useState(true)
  const [sharesForBuyBackErrors, setSharesForBuyBackErrors] = useState<{ [key: string]: string }>({})
  const [buybackTransactionDetailsLoading, setBuybackTransactionDetailsLoading] = useState(false)
  const [buybackTransactionDetails, setBuybackTransactionDetails] = useState<any>(null)
  const { shareSecuirtyClassDropdownDataForBuyback, shareSecuirtyDropdownDataForBuybackLoading } =
    useGetAllSecurityClassesDropdown(TransactionModals.ADD_BUYBACK_TRANSACTION)

  const handleTabChange = (index: number) => {
    setCurrentDocumentStep(index + 1)
  }

  // State hooks using the initial values
  const [sharesForBuyBackValues, setSharesForBuyBackValues] = useState<{
    [key: string]: string
  }>({})

  useEffect(() => {
    if (buybackTransactionDetails?.shareTransactionsDetails) {
      const sharesForBuyBack = buybackTransactionDetails.shareTransactionsDetails.reduce(
        (acc: { [key: string]: string }, transaction: any) => {

          if (
            transaction?.shareTransactionId &&
            transaction.buybackSharesDeducted != null &&
            buybackTransactionDetails?.buybackMethod === BuybackMethods.MANUAL
          ) {
            acc[transaction.shareTransactionId] = transaction.manualSharesDeducted.toString()
          }
          return acc
        },
        {}
      )

      setSharesForBuyBackValues(sharesForBuyBack)
    } else {
      setSharesForBuyBackValues({})
    }
  }, [buybackTransactionDetails?.shareTransactionsDetails]) // eslint-disable-line react-hooks/exhaustive-deps

  const memoizedSetSharesForBuyBackErrors = useCallback((newErrors: any) => {
    setSharesForBuyBackErrors(newErrors);
  }, [setSharesForBuyBackErrors]);

  const memoizedSetSharesForBuyBackValues = useCallback((newValues: any) => {
    setSharesForBuyBackValues(newValues);
  }, [setSharesForBuyBackValues]);

  console.log(sharesForBuyBackValues);


  const options = [
    {
      slug: 'buyback-details',
      title: formatMessage({ id: 'Buyback Details' }),
      subTitle: formatMessage({ id: 'Add details about share buyback' }),
    },
    {
      slug: 'shareholder-allocation',
      title: formatMessage({ id: 'Shareholder Allocation' }),
      subTitle: formatMessage({ id: 'For manual buyback method only' }),
    },
    {
      slug: 'documents',
      title: formatMessage({ id: 'Documents' }),
      subTitle: formatMessage({ id: 'Documentation for the share buyback' }),
    },
  ]

  const userSchema = Yup.object().shape({
    shareClassId: Yup.object()
      .nullable()
      .required(formatMessage({ id: 'Convertible Class is required' })),
    dateOfBuyback: Yup.string()
      .nullable()
      .required(formatMessage({ id: 'Date of Buyback is required' })),
    numberOfShares: Yup.number()
      .nullable()
      .required('Number of Shares is required')
      .min(1, formatMessage({ id: "Number of shares can't be negative or 0" }))
      .test({
        name: 'maxShares',
        exclusive: true,
        message: formatMessage({ id: 'There are not enough shares available' }),
        test: (value: any, ctx: any) => {
          return (
            value <=
            (buybackTransactionDetails?.numberOfShares
              ? shareSecuirtyClassDropdownDataForBuyback.find(
                (shareSecurityClasss) => shareSecurityClasss.id === ctx.parent.shareClassId?.value
              )?.numberOfShares + buybackTransactionDetails?.numberOfShares
              : shareSecuirtyClassDropdownDataForBuyback.find(
                (shareSecurityClasss) => shareSecurityClasss.id === ctx.parent.shareClassId?.value
              )?.numberOfShares)
          )
        },
      }),
    minimumShareDeduction: Yup.number()
      .nullable()
      .min(1, formatMessage({ id: "Minimum share deduction can't be negative or 0" }))
      .test({
        name: 'maxShares',
        exclusive: true,
        message: formatMessage({
          id: 'Minimum share deduction can not be more than number of shares',
        }),
        test: (value: any, ctx: any) => {
          if (value === undefined || value === null) return true
          return value <= ctx.parent.numberOfShares
        },
      }),
    buybackMethod: Yup.object()
      .nullable()
      .required(formatMessage({ id: 'Buyback Method is required' })),
    pricePerShare: Yup.number()
      .nullable()
      .min(1, formatMessage({ id: "Price per share can't be negative or 0" }))
      .test(
        'max-length',
        'Price per share  cannot exceed 20 characters',
        (value) => (value ? value.toString().length <= 20 : true)
      ),
    totalAmountPaid: Yup.number()
      .nullable()
      .min(0, formatMessage({ id: "Total amount paid can't be negative" }))
      .test(
        'max-length',
        'Total amount paid   cannot exceed 20 characters',
        (value) => (value ? value.toString().length <= 20 : true)
      ),
    exchangeRate: Yup.number()
      .nullable()
      .min(0, formatMessage({ id: "Exchange rate can't be negative" }))
      .test(
        'max-length',
        'Exchange rate must not exceed 20 characters',
        (value) => (value ? value.toString().length <= 20 : true)
      ),
  })

  const initialValues = {
    shareClassId: buybackTransactionDetails?.shareClassId
      ? shareSecuirtyClassDropdownDataForBuyback.find(
        (shareClass) => shareClass.id === buybackTransactionDetails?.shareClassId
      )
      : null,
    dateOfBuyback: buybackTransactionDetails?.dateOfBuyback
      ? buybackTransactionDetails?.dateOfBuyback
      : null,
    buybackMethod: buybackTransactionDetails?.buybackMethod
      ? buybackMethodOptions.find(
        (option) => option.value === buybackTransactionDetails?.buybackMethod
      )
      : null,
    numberOfShares: buybackTransactionDetails?.numberOfShares
      ? buybackTransactionDetails?.numberOfShares
      : null,
    minimumShareDeduction: buybackTransactionDetails?.minimumShareDeduction ?? null,
    pricePerShare: buybackTransactionDetails?.pricePerShare
      ? buybackTransactionDetails?.pricePerShare
      : null,
    pricePerShareCurrency:
      currencyOptions.find((currencyId) => currencyId?.name?.split(' ')[0] === companyCurrency)
        ?.value ?? null,
    totalAmountPaid: buybackTransactionDetails?.totalAmountPaid
      ? buybackTransactionDetails?.totalAmountPaid
      : null,
    totalAmountPaidCurrency:
      currencyOptions.find((currencyId) => currencyId?.name?.split(' ')[0] === companyCurrency)
        ?.value ?? null,
    exchangeRate: buybackTransactionDetails?.exchangeRate
      ? buybackTransactionDetails?.exchangeRate
      : null,
    tags: buybackTransactionDetails?.tags ? buybackTransactionDetails?.tags.split(',') : null,
    comments: buybackTransactionDetails?.comments ? buybackTransactionDetails?.comments : null,
    fileIds: buybackTransactionDetails?.documents?.map((document: any) => document.fileId) || [],
    shareTransactionData:
      buybackTransactionDetails?.shareTransactionsDetails &&
        buybackTransactionDetails?.shareTransactionsDetails.length > 0
        ? buybackTransactionDetails?.shareTransactionsDetails
        : [],
  }

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const rawPayload = {
      shareClassId: values?.shareClassId?.value || values?.shareClassId?.id,
      dateOfBuyback: values?.dateOfBuyback,
      buybackMethod: values?.buybackMethod?.value,
      numberOfShares: parseInt(values?.numberOfShares),
      minimumShareDeduction: parseInt(values?.minimumShareDeduction),
      pricePerShare: parseInt(values?.pricePerShare),
      totalAmountPaid: parseInt(values?.totalAmountPaid),
      exchangeRate: parseInt(values?.exchangeRate),
      tags:
        Array.isArray(values?.tags) && values?.tags?.length > 0
          ? values?.tags.join(',')
          : values?.tags
            ? values?.tags
            : null,
      votePerShare: values?.votePerShare,
      comments: values?.comments,
      fileIds: values?.fileIds,
      shareTransactionData: Object.entries(sharesForBuyBackValues).map(
        ([shareTransactionId, numberOfShares]) => ({
          shareTransactionId,
          numberOfShares: parseInt(numberOfShares as string, 10), // Convert string to number
        })
      ),
    }

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== '' &&
          (!isNaN(value) || typeof value === 'string' || value.length > 0)
      )
    )

    try {
      if (!companyId) return
      if (!shareholderId) return
      setIsLoading(true)
      if (buybackTransactionId && buybackTransactionDetails) {
        const {
          data: { data, success, errors },
        } = await updateBuybackTransaction(payload, companyId, buybackTransactionId, shareholderId)

        if (success) {
          resetForm()
          setFiles([])
          setBuybackTransactionDetails(null)
          setIsBuybackTransactionCreateOrUpdate(true)
          setSidebar(4)
          setIsActive()
          setIsLoading(false)
          toast.success(formatMessage({ id: 'Buyback transaction updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBuybackTransactionSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                buyback_transaction_details: data,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBuybackTransactionFailed,
              action: 'normal',
            },
          })
        }
      } else {
        const {
          data: { data, success, errors },
        } = await createBuybackTransaction(payload, companyId, shareholderId)

        if (success) {
          toast.success(formatMessage({ id: 'Buyback transaction created successfully' }))
          resetForm()
          setFiles([])
          setBuybackTransactionDetails(null)
          setIsLoading(false)
          setSidebar(4)
          setIsBuybackTransactionCreateOrUpdate(true)
          setIsActive()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddBuybackTransactionSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                buyback_transaction_details: data,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddBuybackTransactionFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.error('Error:', err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.AddBuybackTransactionFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchBuybackTransactionDetails = async () => {
    if (!buybackTransactionId) return
    if (!shareholderId) return
    if (!companyId) return
    setBuybackTransactionDetailsLoading(true)
    try {
      const {
        data: { success, data },
      } = await getBuybackTransactionById(companyId, shareholderId, buybackTransactionId)
      if (success && data) {
        setBuybackTransactionDetails(data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setBuybackTransactionDetailsLoading(false)
    }
  }

  useEffect(() => {
    fetchBuybackTransactionDetails()
  }, [buybackTransactionId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (buybackTransactionDetails?.documents.length > 0 && isNotInitialized) {
      setFiles(
        buybackTransactionDetails?.documents.map(
          ({ fileId, name }: { fileId: string; name: string }) => ({
            id: fileId,
            name,
          })
        )
      )
    }
  }, [isNotInitialized, buybackTransactionDetails?.documents]) // eslint-disable-line react-hooks/exhaustive-deps

  const nextStep = () => {
    if (currentDocumentStep < 3) {
      setCurrentDocumentStep(currentDocumentStep + 1)
    }
  }
  const prevStep = () => {
    if (currentDocumentStep > 1) {
      setCurrentDocumentStep(currentDocumentStep - 1)
    }
  }

  const [files, setFiles] = useState<any>([])

  const deleteFile = () => {
    if (!deleteFileId) return
    setDeleteLoading(true)
    setFiles(files.filter((file: any) => file.id !== deleteFileId))
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        'fileIds',
        files.filter((file: any) => file.id !== deleteFileId).map((file: any) => file.id)
      )
    }
    setDeleteLoading(false)
    setDeleteShowModal(false)
    toast.success('Document deleted successfully')
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={userSchema}
        onSubmit={handleSubmit}
        innerRef={formikRef}
        enableReinitialize
        validateOnMount
        validateOnChange
      >
        {(formik) => {
          return (
            <Form>
              <Modal
                show={isActive}
                onHide={() => {
                  setIsActive()
                }}
                size='lg'
                fullscreen
              >
                <Modal.Header closeButton>
                  <h2>{formatMessage({ id: 'Add New Share Buyback' })}</h2>
                </Modal.Header>
                <Modal.Body className='container'>
                  <div
                    className='d-flex gap-3 col-md-8 col-12'
                    style={{
                      overflowX: 'scroll',
                      whiteSpace: 'nowrap',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                    }}
                  >
                    <div
                      className='d-flex gap-3 col-md-8 col-12'
                      style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                      }}
                    >
                      {/* Rectangular currentDocumentSteps Start */}
                      {options.map((opt, index) => {
                        const isDisabled =
                          index === 1 &&
                          (!formik.values?.buybackMethod?.value ||
                            !formik.values?.numberOfShares ||
                            !formik.values?.shareClassId)
                        return (
                          <div
                            role='button'
                            key={index}
                            className={
                              `col options-container p-4 align-content-center cursor-pointer` +
                              (currentDocumentStep === index + 1 ? ' selected-option' : '') +
                              (index === 1 &&
                                (!formik.values?.buybackMethod?.value ||
                                  !formik.values?.numberOfShares ||
                                  !formik.values?.shareClassId)
                                ? ' disabled-option'
                                : '')
                            }
                            style={{ maxWidth: '200px', flex: '0 0 auto' }}
                            onClick={() => {
                              if (!isDisabled) {
                                handleTabChange(index)
                              }
                            }}
                            aria-disabled={isDisabled}
                          >
                            <h1 className='m-0'>{formatMessage({ id: opt.title })}</h1>
                            <p className='mt-2' style={{ whiteSpace: 'normal', color: '#383940D9' }}>
                              {formatMessage({ id: opt.subTitle })}
                            </p>
                          </div>
                        )
                      })}
                    </div>
                  </div>

                  <div className='my-8 w-100'>
                    {currentDocumentStep === 1 && (
                      <>
                        <InfoCard2
                          title={formatMessage({ id: 'How to Add Share Buyback Details?' })}
                          desc={formatMessage({
                            id: 'Add details for a new share buyback, including selecting the share, buyback date, number of shares, and exchange rate, along with relevant documentation. Accurately specifying these details ensures precise record-keeping and effective shareholder management.',
                          })}
                          slug={brandingConfig.helpLinks.addBuybackShare}
                          className='w-100 mb-0'
                        />

                        {buybackTransactionDetailsLoading ? (
                          <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                            <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                              <div className='col-md-5 mb-10 mb-md-0'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                              <div className='col-md-5'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                              <div className='col-md-5 mb-10 mb-md-0'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                              <div className='col-md-5'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                              <div className='col-md-5 mb-10 mb-md-0'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                              <div className='col-md-5'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                              <div className='col-md-5 mb-10 mb-md-0'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                              <div className='col-md-5'>
                                <div className='w-50'>
                                  <Skeleton
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                                <div className='mt-2'>
                                  <Skeleton
                                    height={30}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12 mb-8'>
                                <SecurityClassDropdown
                                  buttonLabel={formatMessage({ id: 'Add New Share Class' })} // Button label to add new share class
                                  label={formatMessage({ id: 'Share Class' })} // Label for the dropdown
                                  fieldName='shareClassId' // Updated to reflect a proper field name matching formik's initial values
                                  toolTipText={formatMessage({
                                    id: 'Select class name of share security class', // Tooltip for better clarity
                                  })}
                                  loading={shareSecuirtyDropdownDataForBuybackLoading}
                                  options={
                                    buybackTransactionId
                                      ? shareSecuirtyClassDropdownDataForBuyback
                                      : shareSecuirtyClassDropdownDataForBuyback.filter(
                                        (shareSecurity) => shareSecurity.numberOfShares > 0
                                      )
                                  } // Pass the options correctly
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Select Share Class' })} // Placeholder text for the input
                                  ariaLabel='className' // Aria-label for accessibility
                                  isMarginNotRequired={true}
                                  isTooltipForModal={true}
                                  disabled={buybackTransactionDetails}
                                  noDataLabel='No Share Class Found' // No data label for the dropdown
                                  isButtonHidden={true}
                                  isPopulateData={true}
                                  onButtonClick={() => {
                                    setIsBuybackCreate(true)
                                    setModalType('AddBuybackTransaction')
                                    setIsShareClassDropdown(true)
                                    openModal('AddSecurityClassModal')
                                  }}
                                />
                                {formik.values.shareClassId && (
                                  <div style={{ color: '#4776E6' }}>{`${formik.values.shareClassId.label
                                    } has ${formik.values.shareClassId.shareTransactions
                                      .totalShareCountForTransactions
                                    } shares distributed among ${buybackTransactionId
                                      ? formik.values.shareClassId.shareTransactions
                                        .shareTransactionsDetails.length
                                      : formik.values.shareClassId.shareTransactions.shareTransactionsDetails.filter(
                                        ({ numberOfShares }: { numberOfShares: number }) =>
                                          numberOfShares > 0
                                      ).length
                                    } transactions`}</div>
                                )}
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Date of Buyback' })}
                                  fieldName='dateOfBuyback'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Date of buyback' })}
                                  toolTipText={formatMessage({
                                    id: 'Specify the date of buyback for this Buyback Transaction.',
                                  })}
                                  isStarRequired={true}
                                  isDateOfBirth={true}
                                  isTooltipForModal={true}
                                  onBlur={formik.handleBlur}
                                  isLesserThanShareClassFirstClosingDate={true}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Buyback Method' })}
                                  fieldName='buybackMethod'
                                  placeholder={formatMessage({ id: 'Select Buyback Method' })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'Select the buyback method for this Buyback Transaction.',
                                  })}
                                  options={buybackMethodOptions}
                                  disabled={buybackTransactionDetails}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='number'
                                  label={formatMessage({ id: 'Number of shares' })}
                                  fieldName='numberOfShares'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Number of shares' })}
                                  toolTipText={formatMessage({
                                    id: 'Add the number of shares to be bought back in this Buyback Transaction.',
                                  })}
                                  isStarRequired={true}
                                  isTooltipForModal={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='number'
                                  label={formatMessage({
                                    id: 'Minimum Share Deduction (Up to Available Shares)',
                                  })}
                                  fieldName='minimumShareDeduction'
                                  formik={formik}
                                  placeholder={formatMessage({
                                    id: 'Minimum Share Deduction per Stakeholder',
                                  })}
                                  toolTipText={formatMessage({
                                    id: 'Specify the number of shares to be deducted from per stakeholder.',
                                  })}
                                  isStarRequired={false}
                                  isDisabled={
                                    !(
                                      formik.values.buybackMethod?.value === BuybackMethods.FIFO ||
                                      formik.values.buybackMethod?.value === BuybackMethods.LIFO
                                    ) || buybackTransactionDetails
                                  }
                                  isTooltipForModal={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <InputWithSub
                                  type='number'
                                  fieldName='pricePerShare'
                                  selectOptionFieldName='pricePerShareCurrency'
                                  defaultValue={
                                    formik.values.shareClassId?.pricePerShare
                                      ? formik.values.shareClassId.pricePerShare
                                      : undefined
                                  }
                                  label={formatMessage({ id: 'Price Per Share' })}
                                  placeholder={formatMessage({ id: 'Enter Price Per Share' })}
                                  placeholderSelect='Select Currency'
                                  formik={formik}
                                  options={currencyOptions}
                                  toolTipText={formatMessage({
                                    id: 'Specify a currency and add price per share for this Buyback transaction.',
                                  })}
                                  isStarRequired={true}
                                  isTooltipForModal={true}
                                  isCurrencyDropdown={true}
                                  isDropdownDisabled={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <InputWithSub
                                  type='number'
                                  fieldName='totalAmountPaid'
                                  selectOptionFieldName='totalAmountPaidCurrency'
                                  label={formatMessage({ id: 'Total Amount Paid' })}
                                  placeholder={formatMessage({ id: 'Enter Total Amount Paid' })}
                                  placeholderSelect='Select Currency'
                                  formik={formik}
                                  disabled={true}
                                  options={currencyOptions}
                                  toolTipText={formatMessage({
                                    id: 'Select a currency and add total amount paid for this Buyback Transaction.',
                                  })}
                                  isStarRequired={true}
                                  isTooltipForModal={true}
                                  isCurrencyDropdown={true}
                                  isDropdownDisabled={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='number'
                                  label={formatMessage({ id: 'Exchange Rate' })}
                                  fieldName='exchangeRate'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Exchange rate' })}
                                  toolTipText={formatMessage({
                                    id: 'Specify exchange value for this Buyback Transaction.',
                                  })}
                                  isStarRequired={false}
                                  isTooltipForModal={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12 z-index-0'>
                                <TagifyInput
                                  label={formatMessage({ id: 'Tags' })}
                                  placeholder={formatMessage({ id: 'Enter tags' })}
                                  tooltip={formatMessage({
                                    id: 'Add tags of the Buyback Transaction.',
                                  })}
                                  fieldName='tags'
                                  formik={formik}
                                  defaultValue={buybackTransactionDetails?.tags}
                                />
                              </div>
                              <div className='col-md-12 col-12 mt-5'>
                                <TextArea
                                  label={formatMessage({ id: 'Comments' })}
                                  fieldName='comments'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Comment' })}
                                  toolTipText={formatMessage({
                                    id: 'Add any comment/specification related to this Buyback Transaction that might be important for other shareholders & investors.',
                                  })}
                                  isStarRequired={false}
                                  isTooltipForModal={true}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {currentDocumentStep === 2 && (
                      <DataTableForManualBuyback
                        formik={formik}
                        setSharesForBuyBackErrors={memoizedSetSharesForBuyBackErrors}
                        setSharesForBuyBackValues={memoizedSetSharesForBuyBackValues}
                        buybackTransactionId={buybackTransactionId}
                        sharesForBuyBackValues={sharesForBuyBackValues}
                      />
                    )}

                    {currentDocumentStep === 3 && (
                      <>
                        <InfoCard2
                          title={formatMessage({ id: 'How to Add Share Buyback Details?' })}
                          desc={formatMessage({
                            id: 'Add details for a new share buyback, including selecting the share, buyback date, number of shares, and exchange rate, along with relevant documentation. Accurately specifying these details ensures precise record-keeping and effective shareholder management.',
                          })}
                          slug={brandingConfig.helpLinks.addBuybackShare}
                          className='w-100 mb-0'
                        />
                        <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                          {formatMessage({ id: 'Attach files' })}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Add/upload documents pertaining to this share buyback like Letter of Offer, Share Buyback Agreement, etc. ',
                            })}
                          />
                        </div>
                        <div className='w-100'>
                          <button
                            type='button'
                            className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-100 w-md-auto'
                            onClick={() => setModalStatus(true)}
                          >
                            {formatMessage({ id: 'Import Files' })}
                          </button>
                        </div>

                        <div className='mb-4'>
                          {files.length > 0 && (
                            <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                              {formatMessage({ id: 'Uploaded Files' })}{' '}
                              <ToolTipUIForModal
                                tooltipText={formatMessage({
                                  id: 'Manage all the uploaded documents here.',
                                })}
                              />
                            </div>
                          )}
                          <FileUpload
                            fileSize={parseInt(
                              process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string
                            )}
                            maxFileNumber={10}
                            allowType={allowedFileTypes}
                            metaData={{ module: 'document', isProtected: false }}
                            modalStatus={modalStatus}
                            handleClose={() => {
                              TagManager.dataLayer({
                                dataLayer: {
                                  event:
                                    GTMEvent.BuybackTransactionCreateOrUpdateDocumentsUploadFailed,
                                  action: 'normal',
                                  metadata: {
                                    company_id: companyId,
                                    user_id: currentUser?.userId,
                                    email: currentUser?.email,
                                  },
                                },
                              })
                              setModalStatus(false)
                            }}
                            handleSuccess={(id: number, name: string) => {
                              setIsNotInitialized(false)

                              setFiles((prevFiles: any) => [...prevFiles, { id, name }])

                              if (formikRef.current) {
                                const currentFileIds = Array.isArray(
                                  formikRef.current.values.fileIds
                                )
                                  ? formikRef.current.values.fileIds
                                  : []

                                fileRef.current.push(id) // Store only the current ID
                                const uniqueFileIds = Array.from(
                                  new Set([...currentFileIds, ...fileRef.current])
                                )
                                formikRef.current.setFieldValue('fileIds', uniqueFileIds)
                                TagManager.dataLayer({
                                  dataLayer: {
                                    event:
                                      GTMEvent.BuybackTransactionCreateOrUpdateDocumentsUploadSuccessful,
                                    action: 'normal',
                                    metadata: {
                                      company_id: companyId,
                                      user_id: currentUser?.userId,
                                      email: currentUser?.email,
                                      document_name: name,
                                      document_id: id,
                                    },
                                  },
                                })
                              }
                            }}
                            resourceType='all'
                          />
                          {buybackTransactionDetailsLoading ? (
                            <>
                              <div className='w-50'>
                                <Skeleton
                                  width={'100%'}
                                  height={48}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                              <div className='w-50'>
                                <Skeleton
                                  width={'100%'}
                                  height={48}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                            </>
                          ) : (
                            <div className='w-100'>
                              <ul className='p-0 m-0'>
                                {files?.map((file: any) => (
                                  <li
                                    key={file.id}
                                    className='d-flex align-items-center gap-2 text-decoration-none mb-3 w-100 border border-1 p-2'
                                  >
                                    <div className='d-flex justify-content-between align-items-center w-100'>
                                      <div className='w-100 d-flex align-items-center gap-2'>
                                        <img
                                          src={getFileType(file.name)}
                                          alt={file.name}
                                          style={{ height: '30px', width: '30px' }}
                                        />

                                        <p className='p-0 m-0 max-file-width'>
                                          {file.name.split('/').pop()}
                                        </p>
                                      </div>

                                      <button
                                        type='button'
                                        className='btn btn-secondry p-0 m-0  d-flex align-items-start'
                                        onClick={() => {
                                          setDeleteFileId(file.id)
                                          setDeleteShowModal(true)
                                        }}
                                      >
                                        <img src={deleteicon} alt='Delete' />
                                      </button>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </Modal.Body>
                <Modal.Footer className='container px-0'>
                  <div className='d-md-flex justify-content-end gap-3'>
                    {currentDocumentStep !== 1 ? (
                      <div>
                        <button
                          type='button'
                          className='btn bg-light custom-button-property text-muted'
                          onClick={prevStep}
                        >
                          {formatMessage({ id: 'Back' })}
                        </button>
                      </div>
                    ) : (
                      <div>
                        <button
                          type='submit'
                          className='btn bg-light custom-button-property text-muted'
                          onClick={() => setIsActive()}
                        >
                          {formatMessage({ id: 'Cancel' })}
                        </button>
                      </div>
                    )}
                    <div>
                      {currentDocumentStep < 3 ? (
                        <button
                          type='button'
                          className='btn bg-primary text-white custom-button-property'
                          disabled={
                            !formik.isValid ||
                            ((currentDocumentStep === 2 || currentDocumentStep === 3) &&
                              formik?.values?.buybackMethod?.value === BuybackMethods.MANUAL &&
                              (parseInt(formik.values.numberOfShares, 10) !==
                                Object.values(sharesForBuyBackValues)
                                  .map((val: any) => parseInt(val || '0', 10))
                                  .reduce((acc, curr) => acc + curr, 0) ||
                                Object.values(sharesForBuyBackErrors).some(
                                  (error) => error !== ''
                                )))
                          }
                          onClick={nextStep}
                        >
                          {formatMessage({ id: 'Next' })}
                        </button>
                      ) : (
                        <button
                          type='button'
                          className='btn bg-primary text-white custom-button-property'
                          disabled={!formik.isValid || isLoading}
                          onClick={formik.submitForm}
                        >
                          {!isLoading && (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Submit' })}
                            </span>
                          )}
                          {isLoading && (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Please wait...' })}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }}
      </Formik>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
    </>
  )
}
